export const countries = [
  {
    iso: 'AD',
    emoji: '🇦🇩',
    name: 'Andorra',
  },
  {
    iso: 'AE',
    emoji: '🇦🇪',
    name: 'United Arab Emirates',
  },
  {
    iso: 'AF',
    emoji: '🇦🇫',
    name: 'Afghanistan',
  },
  {
    iso: 'AG',
    emoji: '🇦🇬',
    name: 'Antigua and Barbuda',
  },
  {
    iso: 'AI',
    emoji: '🇦🇮',
    name: 'Anguilla',
  },
  {
    iso: 'AL',
    emoji: '🇦🇱',
    name: 'Albania',
  },
  {
    iso: 'AM',
    emoji: '🇦🇲',
    name: 'Armenia',
  },
  {
    iso: 'AO',
    emoji: '🇦🇴',
    name: 'Angola',
  },
  {
    iso: 'AQ',
    emoji: '🇦🇶',
    name: 'Antarctica',
  },
  {
    iso: 'AR',
    emoji: '🇦🇷',
    name: 'Argentina',
  },
  {
    iso: 'AS',
    emoji: '🇦🇸',
    name: 'American Samoa',
  },
  {
    iso: 'AT',
    emoji: '🇦🇹',
    name: 'Austria',
  },
  {
    iso: 'AU',
    emoji: '🇦🇺',
    name: 'Australia',
  },
  {
    iso: 'AW',
    emoji: '🇦🇼',
    name: 'Aruba',
  },
  {
    iso: 'AX',
    emoji: '🇦🇽',
    name: 'Åland Islands',
  },
  {
    iso: 'AZ',
    emoji: '🇦🇿',
    name: 'Azerbaijan',
  },
  {
    iso: 'BA',
    emoji: '🇧🇦',
    name: 'Bosnia and Herzegovina',
  },
  {
    iso: 'BB',
    emoji: '🇧🇧',
    name: 'Barbados',
  },
  {
    iso: 'BD',
    emoji: '🇧🇩',
    name: 'Bangladesh',
  },
  {
    iso: 'BE',
    emoji: '🇧🇪',
    name: 'Belgium',
  },
  {
    iso: 'BF',
    emoji: '🇧🇫',
    name: 'Burkina Faso',
  },
  {
    iso: 'BG',
    emoji: '🇧🇬',
    name: 'Bulgaria',
  },
  {
    iso: 'BH',
    emoji: '🇧🇭',
    name: 'Bahrain',
  },
  {
    iso: 'BI',
    emoji: '🇧🇮',
    name: 'Burundi',
  },
  {
    iso: 'BJ',
    emoji: '🇧🇯',
    name: 'Benin',
  },
  {
    iso: 'BL',
    emoji: '🇧🇱',
    name: 'Saint Barthélemy',
  },
  {
    iso: 'BM',
    emoji: '🇧🇲',
    name: 'Bermuda',
  },
  {
    iso: 'BN',
    emoji: '🇧🇳',
    name: 'Brunei Darussalam',
  },
  {
    iso: 'BO',
    emoji: '🇧🇴',
    name: 'Bolivia',
  },
  {
    iso: 'BQ',
    emoji: '🇧🇶',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    iso: 'BR',
    emoji: '🇧🇷',
    name: 'Brazil',
  },
  {
    iso: 'BS',
    emoji: '🇧🇸',
    name: 'Bahamas',
  },
  {
    iso: 'BT',
    emoji: '🇧🇹',
    name: 'Bhutan',
  },
  {
    iso: 'BV',
    emoji: '🇧🇻',
    name: 'Bouvet Island',
  },
  {
    iso: 'BW',
    emoji: '🇧🇼',
    name: 'Botswana',
  },
  {
    iso: 'BY',
    emoji: '🇧🇾',
    name: 'Belarus',
  },
  {
    iso: 'BZ',
    emoji: '🇧🇿',
    name: 'Belize',
  },
  {
    iso: 'CA',
    emoji: '🇨🇦',
    name: 'Canada',
  },
  {
    iso: 'CC',
    emoji: '🇨🇨',
    name: 'Cocos (Keeling) Islands',
  },
  {
    iso: 'CD',
    emoji: '🇨🇩',
    name: 'Congo',
  },
  {
    iso: 'CF',
    emoji: '🇨🇫',
    name: 'Central African Republic',
  },
  {
    iso: 'CG',
    emoji: '🇨🇬',
    name: 'Congo',
  },
  {
    iso: 'CH',
    emoji: '🇨🇭',
    name: 'Switzerland',
  },
  {
    iso: 'CI',
    emoji: '🇨🇮',
    name: "Côte D'Ivoire",
  },
  {
    iso: 'CK',
    emoji: '🇨🇰',
    name: 'Cook Islands',
  },
  {
    iso: 'CL',
    emoji: '🇨🇱',
    name: 'Chile',
  },
  {
    iso: 'CM',
    emoji: '🇨🇲',
    name: 'Cameroon',
  },
  {
    iso: 'CN',
    emoji: '🇨🇳',
    name: 'China',
  },
  {
    iso: 'CO',
    emoji: '🇨🇴',
    name: 'Colombia',
  },
  {
    iso: 'CR',
    emoji: '🇨🇷',
    name: 'Costa Rica',
  },
  {
    iso: 'CU',
    emoji: '🇨🇺',
    name: 'Cuba',
  },
  {
    iso: 'CV',
    emoji: '🇨🇻',
    name: 'Cape Verde',
  },
  {
    iso: 'CW',
    emoji: '🇨🇼',
    name: 'Curaçao',
  },
  {
    iso: 'CX',
    emoji: '🇨🇽',
    name: 'Christmas Island',
  },
  {
    iso: 'CY',
    emoji: '🇨🇾',
    name: 'Cyprus',
  },
  {
    iso: 'CZ',
    emoji: '🇨🇿',
    name: 'Czech Republic',
  },
  {
    iso: 'DE',
    emoji: '🇩🇪',
    name: 'Germany',
  },
  {
    iso: 'DJ',
    emoji: '🇩🇯',
    name: 'Djibouti',
  },
  {
    iso: 'DK',
    emoji: '🇩🇰',
    name: 'Denmark',
  },
  {
    iso: 'DM',
    emoji: '🇩🇲',
    name: 'Dominica',
  },
  {
    iso: 'DO',
    emoji: '🇩🇴',
    name: 'Dominican Republic',
  },
  {
    iso: 'DZ',
    emoji: '🇩🇿',
    name: 'Algeria',
  },
  {
    iso: 'EC',
    emoji: '🇪🇨',
    name: 'Ecuador',
  },
  {
    iso: 'EE',
    emoji: '🇪🇪',
    name: 'Estonia',
  },
  {
    iso: 'EG',
    emoji: '🇪🇬',
    name: 'Egypt',
  },
  {
    iso: 'EH',
    emoji: '🇪🇭',
    name: 'Western Sahara',
  },
  {
    iso: 'ER',
    emoji: '🇪🇷',
    name: 'Eritrea',
  },
  {
    iso: 'ES',
    emoji: '🇪🇸',
    name: 'Spain',
  },
  {
    iso: 'ET',
    emoji: '🇪🇹',
    name: 'Ethiopia',
  },
  {
    iso: 'FI',
    emoji: '🇫🇮',
    name: 'Finland',
  },
  {
    iso: 'FJ',
    emoji: '🇫🇯',
    name: 'Fiji',
  },
  {
    iso: 'FK',
    emoji: '🇫🇰',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    iso: 'FM',
    emoji: '🇫🇲',
    name: 'Micronesia',
  },
  {
    iso: 'FO',
    emoji: '🇫🇴',
    name: 'Faroe Islands',
  },
  {
    iso: 'FR',
    emoji: '🇫🇷',
    name: 'France',
  },
  {
    iso: 'GA',
    emoji: '🇬🇦',
    name: 'Gabon',
  },
  {
    iso: 'GB',
    emoji: '🇬🇧',
    name: 'United Kingdom',
  },
  {
    iso: 'GD',
    emoji: '🇬🇩',
    name: 'Grenada',
  },
  {
    iso: 'GE',
    emoji: '🇬🇪',
    name: 'Georgia',
  },
  {
    iso: 'GF',
    emoji: '🇬🇫',
    name: 'French Guiana',
  },
  {
    iso: 'GG',
    emoji: '🇬🇬',
    name: 'Guernsey',
  },
  {
    iso: 'GH',
    emoji: '🇬🇭',
    name: 'Ghana',
  },
  {
    iso: 'GI',
    emoji: '🇬🇮',
    name: 'Gibraltar',
  },
  {
    iso: 'GL',
    emoji: '🇬🇱',
    name: 'Greenland',
  },
  {
    iso: 'GM',
    emoji: '🇬🇲',
    name: 'Gambia',
  },
  {
    iso: 'GN',
    emoji: '🇬🇳',
    name: 'Guinea',
  },
  {
    iso: 'GP',
    emoji: '🇬🇵',
    name: 'Guadeloupe',
  },
  {
    iso: 'GQ',
    emoji: '🇬🇶',
    name: 'Equatorial Guinea',
  },
  {
    iso: 'GR',
    emoji: '🇬🇷',
    name: 'Greece',
  },
  {
    iso: 'GS',
    emoji: '🇬🇸',
    name: 'South Georgia',
  },
  {
    iso: 'GT',
    emoji: '🇬🇹',
    name: 'Guatemala',
  },
  {
    iso: 'GU',
    emoji: '🇬🇺',
    name: 'Guam',
  },
  {
    iso: 'GW',
    emoji: '🇬🇼',
    name: 'Guinea-Bissau',
  },
  {
    iso: 'GY',
    emoji: '🇬🇾',
    name: 'Guyana',
  },
  {
    iso: 'HK',
    emoji: '🇭🇰',
    name: 'Hong Kong',
  },
  {
    iso: 'HM',
    emoji: '🇭🇲',
    name: 'Heard Island and Mcdonald Islands',
  },
  {
    iso: 'HN',
    emoji: '🇭🇳',
    name: 'Honduras',
  },
  {
    iso: 'HR',
    emoji: '🇭🇷',
    name: 'Croatia',
  },
  {
    iso: 'HT',
    emoji: '🇭🇹',
    name: 'Haiti',
  },
  {
    iso: 'HU',
    emoji: '🇭🇺',
    name: 'Hungary',
  },
  {
    iso: 'ID',
    emoji: '🇮🇩',
    name: 'Indonesia',
  },
  {
    iso: 'IE',
    emoji: '🇮🇪',
    name: 'Ireland',
  },
  {
    iso: 'IL',
    emoji: '🇮🇱',
    name: 'Israel',
  },
  {
    iso: 'IM',
    emoji: '🇮🇲',
    name: 'Isle of Man',
  },
  {
    iso: 'IN',
    emoji: '🇮🇳',
    name: 'India',
  },
  {
    iso: 'IO',
    emoji: '🇮🇴',
    name: 'British Indian Ocean Territory',
  },
  {
    iso: 'IQ',
    emoji: '🇮🇶',
    name: 'Iraq',
  },
  {
    iso: 'IR',
    emoji: '🇮🇷',
    name: 'Iran',
  },
  {
    iso: 'IS',
    emoji: '🇮🇸',
    name: 'Iceland',
  },
  {
    iso: 'IT',
    emoji: '🇮🇹',
    name: 'Italy',
  },
  {
    iso: 'JE',
    emoji: '🇯🇪',
    name: 'Jersey',
  },
  {
    iso: 'JM',
    emoji: '🇯🇲',
    name: 'Jamaica',
  },
  {
    iso: 'JO',
    emoji: '🇯🇴',
    name: 'Jordan',
  },
  {
    iso: 'JP',
    emoji: '🇯🇵',
    name: 'Japan',
  },
  {
    iso: 'KE',
    emoji: '🇰🇪',
    name: 'Kenya',
  },
  {
    iso: 'KG',
    emoji: '🇰🇬',
    name: 'Kyrgyzstan',
  },
  {
    iso: 'KH',
    emoji: '🇰🇭',
    name: 'Cambodia',
  },
  {
    iso: 'KI',
    emoji: '🇰🇮',
    name: 'Kiribati',
  },
  {
    iso: 'KM',
    emoji: '🇰🇲',
    name: 'Comoros',
  },
  {
    iso: 'KN',
    emoji: '🇰🇳',
    name: 'Saint Kitts and Nevis',
  },
  {
    iso: 'KP',
    emoji: '🇰🇵',
    name: 'North Korea',
  },
  {
    iso: 'KR',
    emoji: '🇰🇷',
    name: 'South Korea',
  },
  {
    iso: 'KW',
    emoji: '🇰🇼',
    name: 'Kuwait',
  },
  {
    iso: 'KY',
    emoji: '🇰🇾',
    name: 'Cayman Islands',
  },
  {
    iso: 'KZ',
    emoji: '🇰🇿',
    name: 'Kazakhstan',
  },
  {
    iso: 'LA',
    emoji: '🇱🇦',
    name: "Lao People's Democratic Republic",
  },
  {
    iso: 'LB',
    emoji: '🇱🇧',
    name: 'Lebanon',
  },
  {
    iso: 'LC',
    emoji: '🇱🇨',
    name: 'Saint Lucia',
  },
  {
    iso: 'LI',
    emoji: '🇱🇮',
    name: 'Liechtenstein',
  },
  {
    iso: 'LK',
    emoji: '🇱🇰',
    name: 'Sri Lanka',
  },
  {
    iso: 'LR',
    emoji: '🇱🇷',
    name: 'Liberia',
  },
  {
    iso: 'LS',
    emoji: '🇱🇸',
    name: 'Lesotho',
  },
  {
    iso: 'LT',
    emoji: '🇱🇹',
    name: 'Lithuania',
  },
  {
    iso: 'LU',
    emoji: '🇱🇺',
    name: 'Luxembourg',
  },
  {
    iso: 'LV',
    emoji: '🇱🇻',
    name: 'Latvia',
  },
  {
    iso: 'LY',
    emoji: '🇱🇾',
    name: 'Libya',
  },
  {
    iso: 'MA',
    emoji: '🇲🇦',
    name: 'Morocco',
  },
  {
    iso: 'MC',
    emoji: '🇲🇨',
    name: 'Monaco',
  },
  {
    iso: 'MD',
    emoji: '🇲🇩',
    name: 'Moldova',
  },
  {
    iso: 'ME',
    emoji: '🇲🇪',
    name: 'Montenegro',
  },
  {
    iso: 'MF',
    emoji: '🇲🇫',
    name: 'Saint Martin (French Part)',
  },
  {
    iso: 'MG',
    emoji: '🇲🇬',
    name: 'Madagascar',
  },
  {
    iso: 'MH',
    emoji: '🇲🇭',
    name: 'Marshall Islands',
  },
  {
    iso: 'MK',
    emoji: '🇲🇰',
    name: 'Macedonia',
  },
  {
    iso: 'ML',
    emoji: '🇲🇱',
    name: 'Mali',
  },
  {
    iso: 'MM',
    emoji: '🇲🇲',
    name: 'Myanmar',
  },
  {
    iso: 'MN',
    emoji: '🇲🇳',
    name: 'Mongolia',
  },
  {
    iso: 'MO',
    emoji: '🇲🇴',
    name: 'Macao',
  },
  {
    iso: 'MP',
    emoji: '🇲🇵',
    name: 'Northern Mariana Islands',
  },
  {
    iso: 'MQ',
    emoji: '🇲🇶',
    name: 'Martinique',
  },
  {
    iso: 'MR',
    emoji: '🇲🇷',
    name: 'Mauritania',
  },
  {
    iso: 'MS',
    emoji: '🇲🇸',
    name: 'Montserrat',
  },
  {
    iso: 'MT',
    emoji: '🇲🇹',
    name: 'Malta',
  },
  {
    iso: 'MU',
    emoji: '🇲🇺',
    name: 'Mauritius',
  },
  {
    iso: 'MV',
    emoji: '🇲🇻',
    name: 'Maldives',
  },
  {
    iso: 'MW',
    emoji: '🇲🇼',
    name: 'Malawi',
  },
  {
    iso: 'MX',
    emoji: '🇲🇽',
    name: 'Mexico',
  },
  {
    iso: 'MY',
    emoji: '🇲🇾',
    name: 'Malaysia',
  },
  {
    iso: 'MZ',
    emoji: '🇲🇿',
    name: 'Mozambique',
  },
  {
    iso: 'NA',
    emoji: '🇳🇦',
    name: 'Namibia',
  },
  {
    iso: 'NC',
    emoji: '🇳🇨',
    name: 'New Caledonia',
  },
  {
    iso: 'NE',
    emoji: '🇳🇪',
    name: 'Niger',
  },
  {
    iso: 'NF',
    emoji: '🇳🇫',
    name: 'Norfolk Island',
  },
  {
    iso: 'NG',
    emoji: '🇳🇬',
    name: 'Nigeria',
  },
  {
    iso: 'NI',
    emoji: '🇳🇮',
    name: 'Nicaragua',
  },
  {
    iso: 'NL',
    emoji: '🇳🇱',
    name: 'Netherlands',
  },
  {
    iso: 'NO',
    emoji: '🇳🇴',
    name: 'Norway',
  },
  {
    iso: 'NP',
    emoji: '🇳🇵',
    name: 'Nepal',
  },
  {
    iso: 'NR',
    emoji: '🇳🇷',
    name: 'Nauru',
  },
  {
    iso: 'NU',
    emoji: '🇳🇺',
    name: 'Niue',
  },
  {
    iso: 'NZ',
    emoji: '🇳🇿',
    name: 'New Zealand',
  },
  {
    iso: 'OM',
    emoji: '🇴🇲',
    name: 'Oman',
  },
  {
    iso: 'PA',
    emoji: '🇵🇦',
    name: 'Panama',
  },
  {
    iso: 'PE',
    emoji: '🇵🇪',
    name: 'Peru',
  },
  {
    iso: 'PF',
    emoji: '🇵🇫',
    name: 'French Polynesia',
  },
  {
    iso: 'PG',
    emoji: '🇵🇬',
    name: 'Papua New Guinea',
  },
  {
    iso: 'PH',
    emoji: '🇵🇭',
    name: 'Philippines',
  },
  {
    iso: 'PK',
    emoji: '🇵🇰',
    name: 'Pakistan',
  },
  {
    iso: 'PL',
    emoji: '🇵🇱',
    name: 'Poland',
  },
  {
    iso: 'PM',
    emoji: '🇵🇲',
    name: 'Saint Pierre and Miquelon',
  },
  {
    iso: 'PN',
    emoji: '🇵🇳',
    name: 'Pitcairn',
  },
  {
    iso: 'PR',
    emoji: '🇵🇷',
    name: 'Puerto Rico',
  },
  {
    iso: 'PS',
    emoji: '🇵🇸',
    name: 'Palestinian Territory',
  },
  {
    iso: 'PT',
    emoji: '🇵🇹',
    name: 'Portugal',
  },
  {
    iso: 'PW',
    emoji: '🇵🇼',
    name: 'Palau',
  },
  {
    iso: 'PY',
    emoji: '🇵🇾',
    name: 'Paraguay',
  },
  {
    iso: 'QA',
    emoji: '🇶🇦',
    name: 'Qatar',
  },
  {
    iso: 'RE',
    emoji: '🇷🇪',
    name: 'Réunion',
  },
  {
    iso: 'RO',
    emoji: '🇷🇴',
    name: 'Romania',
  },
  {
    iso: 'RS',
    emoji: '🇷🇸',
    name: 'Serbia',
  },
  {
    iso: 'RU',
    emoji: '🇷🇺',
    name: 'Russia',
  },
  {
    iso: 'RW',
    emoji: '🇷🇼',
    name: 'Rwanda',
  },
  {
    iso: 'SA',
    emoji: '🇸🇦',
    name: 'Saudi Arabia',
  },
  {
    iso: 'SB',
    emoji: '🇸🇧',
    name: 'Solomon Islands',
  },
  {
    iso: 'SC',
    emoji: '🇸🇨',
    name: 'Seychelles',
  },
  {
    iso: 'SD',
    emoji: '🇸🇩',
    name: 'Sudan',
  },
  {
    iso: 'SE',
    emoji: '🇸🇪',
    name: 'Sweden',
  },
  {
    iso: 'SG',
    emoji: '🇸🇬',
    name: 'Singapore',
  },
  {
    iso: 'SH',
    emoji: '🇸🇭',
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
  },
  {
    iso: 'SI',
    emoji: '🇸🇮',
    name: 'Slovenia',
  },
  {
    iso: 'SJ',
    emoji: '🇸🇯',
    name: 'Svalbard and Jan Mayen',
  },
  {
    iso: 'SK',
    emoji: '🇸🇰',
    name: 'Slovakia',
  },
  {
    iso: 'SL',
    emoji: '🇸🇱',
    name: 'Sierra Leone',
  },
  {
    iso: 'SM',
    emoji: '🇸🇲',
    name: 'San Marino',
  },
  {
    iso: 'SN',
    emoji: '🇸🇳',
    name: 'Senegal',
  },
  {
    iso: 'SO',
    emoji: '🇸🇴',
    name: 'Somalia',
  },
  {
    iso: 'SR',
    emoji: '🇸🇷',
    name: 'Suriname',
  },
  {
    iso: 'SS',
    emoji: '🇸🇸',
    name: 'South Sudan',
  },
  {
    iso: 'ST',
    emoji: '🇸🇹',
    name: 'Sao Tome and Principe',
  },
  {
    iso: 'SV',
    emoji: '🇸🇻',
    name: 'El Salvador',
  },
  {
    iso: 'SX',
    emoji: '🇸🇽',
    name: 'Sint Maarten (Dutch Part)',
  },
  {
    iso: 'SY',
    emoji: '🇸🇾',
    name: 'Syrian Arab Republic',
  },
  {
    iso: 'SZ',
    emoji: '🇸🇿',
    name: 'Swaziland',
  },
  {
    iso: 'TC',
    emoji: '🇹🇨',
    name: 'Turks and Caicos Islands',
  },
  {
    iso: 'TD',
    emoji: '🇹🇩',
    name: 'Chad',
  },
  {
    iso: 'TF',
    emoji: '🇹🇫',
    name: 'French Southern Territories',
  },
  {
    iso: 'TG',
    emoji: '🇹🇬',
    name: 'Togo',
  },
  {
    iso: 'TH',
    emoji: '🇹🇭',
    name: 'Thailand',
  },
  {
    iso: 'TJ',
    emoji: '🇹🇯',
    name: 'Tajikistan',
  },
  {
    iso: 'TK',
    emoji: '🇹🇰',
    name: 'Tokelau',
  },
  {
    iso: 'TL',
    emoji: '🇹🇱',
    name: 'Timor-Leste',
  },
  {
    iso: 'TM',
    emoji: '🇹🇲',
    name: 'Turkmenistan',
  },
  {
    iso: 'TN',
    emoji: '🇹🇳',
    name: 'Tunisia',
  },
  {
    iso: 'TO',
    emoji: '🇹🇴',
    name: 'Tonga',
  },
  {
    iso: 'TR',
    emoji: '🇹🇷',
    name: 'Turkey',
  },
  {
    iso: 'TT',
    emoji: '🇹🇹',
    name: 'Trinidad and Tobago',
  },
  {
    iso: 'TV',
    emoji: '🇹🇻',
    name: 'Tuvalu',
  },
  {
    iso: 'TW',
    emoji: '🇹🇼',
    name: 'Taiwan',
  },
  {
    iso: 'TZ',
    emoji: '🇹🇿',
    name: 'Tanzania',
  },
  {
    iso: 'UA',
    emoji: '🇺🇦',
    name: 'Ukraine',
  },
  {
    iso: 'UG',
    emoji: '🇺🇬',
    name: 'Uganda',
  },
  {
    iso: 'UM',
    emoji: '🇺🇲',
    name: 'United States Minor Outlying Islands',
  },
  {
    iso: 'US',
    emoji: '🇺🇸',
    name: 'United States',
  },
  {
    iso: 'UY',
    emoji: '🇺🇾',
    name: 'Uruguay',
  },
  {
    iso: 'UZ',
    emoji: '🇺🇿',
    name: 'Uzbekistan',
  },
  {
    iso: 'VA',
    emoji: '🇻🇦',
    name: 'Vatican City',
  },
  {
    iso: 'VC',
    emoji: '🇻🇨',
    name: 'Saint Vincent and The Grenadines',
  },
  {
    iso: 'VE',
    emoji: '🇻🇪',
    name: 'Venezuela',
  },
  {
    iso: 'VG',
    emoji: '🇻🇬',
    name: 'Virgin Islands, British',
  },
  {
    iso: 'VI',
    emoji: '🇻🇮',
    name: 'Virgin Islands, U.S.',
  },
  {
    iso: 'VN',
    emoji: '🇻🇳',
    name: 'Viet Nam',
  },
  {
    iso: 'VU',
    emoji: '🇻🇺',
    name: 'Vanuatu',
  },
  {
    iso: 'WF',
    emoji: '🇼🇫',
    name: 'Wallis and Futuna',
  },
  {
    iso: 'WS',
    emoji: '🇼🇸',
    name: 'Samoa',
  },
  {
    iso: 'YE',
    emoji: '🇾🇪',
    name: 'Yemen',
  },
  {
    iso: 'YT',
    emoji: '🇾🇹',
    name: 'Mayotte',
  },
  {
    iso: 'ZA',
    emoji: '🇿🇦',
    name: 'South Africa',
  },
  {
    iso: 'ZM',
    emoji: '🇿🇲',
    name: 'Zambia',
  },
  {
    iso: 'ZW',
    emoji: '🇿🇼',
    name: 'Zimbabwe',
  },
]
